module.exports = __webpack_public_path__ + "static/media/hero_img_apis.9ed335a9.png";